<template>
  <div id="bodyOverview">
    <div id="search">
      <div class="icon"><FontAwesomeIcon icon="search" /></div>
      <!-- <input type="text" v-model="searchStr" @keyup.enter="search(searchStr)" placeholder="搜尋商店名稱/ID" /> -->
      <RmoteSearch
        @change-account="changeAccount($event)"
        :isInitialize="isInitialize"
      />
      <a class="icon" @click="reset()"><FontAwesomeIcon icon="times"/></a>
    </div>
    <h2>{{ displayAccountName }}</h2>
    <div id="container" v-if="accountId">
      <!-- Menu -->
      <div id="tabs">
        <!-- Tab -->
        <TabButton
          v-for="tab in tabs"
          v-bind:key="tab.value"
          v-bind:classA="['tab', { active: currentTab === tab.value }]"
          @click="tabButtonClick(tab.value);"
          :value="tab.value"
          :label="tab.label"
          :warning="tab.warning"
        >
          <template v-slot:icon v-if="tab.value === 'Store'"
            ><div class="icon"><font-awesome-icon icon="store" /></div
          ></template>
          <template v-slot:icon v-else-if="tab.value === 'Advance'"
            ><div class="icon"><font-awesome-icon icon="sliders-h" /></div
          ></template>
          <template v-slot:icon v-else-if="tab.value === 'Notification'"
            ><div class="icon"><font-awesome-icon icon="bell" /></div
          ></template>
          <template v-slot:icon v-else-if="tab.value === 'Time'"
            ><div class="icon"><font-awesome-icon icon="calendar-alt" /></div
          ></template>
          <template v-slot:icon v-else-if="tab.value === 'Logistic'"
            ><div class="icon"><font-awesome-icon icon="truck" /></div
          ></template>
          <template v-slot:icon v-else-if="tab.value === 'Printer'"
            ><div class="icon"><font-awesome-icon icon="receipt" /></div
          ></template>
          <template v-slot:icon v-else-if="tab.value === 'Scanner'"
            ><div class="icon"><font-awesome-icon icon="expand" /></div
          ></template>
          <template v-slot:icon v-else-if="tab.value === 'Qrpay'"
            ><div class="icon"><font-awesome-icon icon="coins" /></div
          ></template>
          <template v-slot:icon v-else-if="tab.value === 'Contract'"
            ><div class="icon"><font-awesome-icon icon="file-contract" /></div
          ></template>
          <template v-slot:icon v-else-if="tab.value === 'Promotion'"
            ><div class="icon"><font-awesome-icon icon="tags" /></div
          ></template>
          <template v-slot:icon v-else-if="tab.value === 'Other'"
            ><div class="icon"><font-awesome-icon icon="link" /></div
          ></template>
          <template v-slot:icon v-else-if="tab.value === 'EInvoice'"
            ><div class="icon"><font-awesome-icon icon="receipt" /></div
          ></template>
          <template v-slot:icon v-else-if="tab.value === 'Record'"
            ><div class="icon"><font-awesome-icon icon="database" /></div
          ></template>

          <div v-if="tab.value === 'Store'">
            <div class="areaH">
              <div class="areaV">
                <span>{{ $t('AccountSettingDefault.Store.Children.System_Status')}}</span>
                <span>{{ $t('AccountSettingDefault.Store.Children.Pickup_Method')}}</span>
                <span>{{ $t('AccountSettingDefault.Store.Children.Payment_Method')}}</span>
                <span>{{ $t('AccountSettingDefault.Store.Children.Announcement')}}</span>
              </div>
              <div class="areaV">
                <span>{{ $t('AccountSettingDefault.Store.Children.Business_Information')}}</span>
                <span>{{ $t('AccountSettingDefault.Store.Children.Applicant_Information')}}</span>
                <span>{{ $t('AccountSettingDefault.Store.Children.Store_Information')}}</span>
                <span>{{ $t('AccountSettingDefault.Store.Children.System_Information')}}</span>
              </div>
            </div>
          </div>
          <div v-else-if="tab.value === 'Time'">
            <div class="areaH">
              <div class="areaV">
                <span>{{ $t('AccountSettingDefault.Time.Children.Meal_Periods')}}</span>
                <span>{{ $t('AccountSettingDefault.Time.Children.Preparation_Time')}}</span>
                <span>{{ $t('AccountSettingDefault.Time.Children.Booking_In_Advance')}}</span>
                <span>{{ $t('AccountSettingDefault.Time.Children.Time_Slot_Interval')}}</span>
              </div>
              <div class="areaV">
                <span>{{ $t('AccountSettingDefault.Time.Children.Capacity_Control_Limitation')}}</span>
                <span>{{ $t('AccountSettingDefault.Time.Children.Business_Hours')}}</span>
                <span>{{ $t('AccountSettingDefault.Time.Children.Off_Days')}}</span>
              </div>
            </div>
          </div>
          <div v-else-if="tab.value === 'Logistic'">
            <div class="areaH">
              <div class="areaV">
                <span>{{ $t('AccountSettingDefault.Logistic.Children.Delivery_Version')}}</span>
              </div>
              <div class="areaV">
                <span>{{ $t('AccountSettingDefault.Logistic.Children.Delivery_Conditions')}}</span>
              </div>
            </div>
          </div>
          <div v-else-if="tab.value === 'Printer'">
            <div class="areaH">
              <div class="areaV">
                <span>{{ $t('AccountSettingDefault.Printer.Children.Custom_Template')}}</span>
              </div>
              <div class="areaV">
                <span>{{ $t('AccountSettingDefault.Printer.Children.Label_Printer_Settings')}}</span>
              </div>
            </div>
          </div>
          <div v-else-if="tab.value === 'Qrpay'">
            <div class="areaH">
              <div class="areaV">
                <span>{{ $t('AccountSettingDefault.Qrpay.Children.LINE_Pay')}}</span>
              </div>
              <div class="areaV">
                <span>{{ $t('AccountSettingDefault.Qrpay.Children.Apple_Pay')}}</span>
              </div>
            </div>
          </div>
        </TabButton>
      </div>

      <keep-alive>
        <component
          :is="currentTabComponent"
          :accountId="numberedAccountId"
          class="tab"
          :value="currentTab"
          :shopId="shopId"
          :shopName="shopName"
          :initialize="toggleRecord"
          @edit-status="changeTabToEdit($event)"
          @saved-status="changeTabToSaved($event)"
        ></component>
      </keep-alive>
  </div>
 
</div>
</template>

<script>
import AccountSettingStore from "./AccountSetting/Store";
import AccountSettingAdvance from "./AccountSetting/Advance";
import AccountSettingTime from "./AccountSetting/Time";
import AccountSettingLogistic from "./AccountSetting/Logistic";
import AccountSettingPrinter from "./AccountSetting/Printer";
import AccountSettingQrpay from "./AccountSetting/Qrpay";
import AccountSettingContract from "./AccountSetting/Contract";
import AccountSettingPromotion from "./AccountSetting/Promotion";
import AccountSettingOther from "./AccountSetting/Other.vue";
import AccountSettingEInvoice from "./AccountSetting/EInvoice";
import AccountSettingRecord from "./AccountSetting/Record";
import AccountSettingNotification from "./AccountSetting/Notification";
import AccountSettingScanner from "./AccountSetting/Scanner";

import TabButton from "./AccountSetting/TabButton";
import RmoteSearch from "src/components/Search/RemoteSearch";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  components: {
    AccountSettingStore,
    AccountSettingAdvance,
    AccountSettingTime,
    AccountSettingLogistic,
    AccountSettingPrinter,
    AccountSettingQrpay,
    AccountSettingContract,
    AccountSettingPromotion,
    AccountSettingOther,
    AccountSettingEInvoice,
    AccountSettingRecord,
    AccountSettingNotification,
    AccountSettingScanner,
    TabButton,
    FontAwesomeIcon,
    RmoteSearch
  },
  data() {
    return {
      isInitialize: false,
      searchStr: "",
      accountId: null,
      shopId: null,//accounts.shop_id, AKA WifiOTG ID
      shopName: null,//accounts.name
      currentTab: this.$route.params.type === "si" ? "Logistic" : "Store",
      
      displayAccountName: "",
      editStatusArr: [],
      toggleRecord: false
    };
  },
  methods: {
    search(searchStr) {
      this.accountId = null;
      if (searchStr) {
        this.$nextTick(function() {
          this.accountId = Number(searchStr);
        });
      }
    },
    changeAccount(option) {
      let accountId = option.value;
      this.displayAccountName = option.label;
      this.shopId = option.shopId;
      this.shopName = option.shopName;
      this.accountId = null;
      this.$nextTick(function() {
        this.accountId = Number(accountId);
      });
    },
    reset() {
      this.$nextTick(function() {
        this.accountId = null;
      });
      this.isInitialize = !this.isInitialize;
      this.displayAccountName = "";
    },
    changeTabToEdit(event) {
      console.log("changeTabToEdit event: ", event);
      let editStatusIndex = this.editStatusArr.findIndex(
        d => d.value == event.value
      );
      if (editStatusIndex == -1) {
        this.editStatusArr.push(event);
      }
      console.log("this.editStatusArr: ", this.editStatusArr)
    },
    changeTabToSaved(event) {
      console.log("changeTabToSaved event: ", event);
      let editStatusIndex = this.editStatusArr.findIndex(
        d => d.value == event.value
      );
      if (editStatusIndex != -1) {
        this.editStatusArr.splice(editStatusIndex, 1);
      }
      console.log("this.editStatusArr: ", this.editStatusArr)
    },
    changeState(currentTab) {
      if(currentTab == 'Record') {
        this.toggleRecord = !this.toggleRecord;
        return this.toggleRecord;
      }
    },
    tabButtonClick(value) {
      this.currentTab = value;
      this.changeState(this.currentTab);
    }
  },
  computed: {
    tabs() {
     const type = this.$route.params.type;
     let activeTabs = [
        {
          value: "Store",
          label: this.$t("AccountSettingDefault.Store.Name"),
          warning: false
        },
        {
          value: "Advance",
          label: this.$t("AccountSettingDefault.Advance.Name"),
          warning: false
        },
        {
          value: "Notification",
          label: this.$t("AccountSettingDefault.Notification.Name"),
          warning: false
        },
        {
          value: "Time",
          label: this.$t("AccountSettingDefault.Time.Name"),
          warning: false
        },
        {
          value: "Logistic",
          label: this.$t("AccountSettingDefault.Logistic.Name"),
          warning: false
        },
        {
          value: "Printer",
          label: this.$t("AccountSettingDefault.Printer.Name"),
          warning: false
        },
        {
          value: "Scanner",
          label: this.$t("AccountSettingDefault.Scanner.Name"),
          warning: false
        },
        // {
        //   value: "Qrpay",
        //   label: "金流",
        //   warning: false
        // },
        {
          value: "Contract",
          label: this.$t("AccountSettingDefault.Contract.Name"),
          warning: false
        },
        {
          value: "Promotion",
          label: this.$t("AccountSettingDefault.Promotion.Name"),
          warning: false
        },
        {
          value: "Other",
          label: this.$t("AccountSettingDefault.Other.Name"),
          warning: false
        },
        {
          value: 'Qrpay',
          label: this.$t("AccountSettingDefault.Qrpay.Name"),
          warning: false
        },
        {
          value: "EInvoice",
          label: this.$t("AccountSettingDefault.EInvoice.Name"),
          warning: false
        },
        {
          value: "Record",
          label: this.$t("AccountSettingDefault.Record.Name"),
          warning: false
        }
      ];
     switch (type) {
      case 'eaa':
        activeTabs = [
          {
            value: "Store",
            label: this.$t("AccountSettingDefault.Store.Name"),
            warning: false
          },
          {
            value: "Notification",
            label: this.$t("AccountSettingDefault.Notification.Name"),
            warning: false
          },
          {
            value: "Time",
            label: this.$t("AccountSettingDefault.Time.Name"),
            warning: false
          },
          {
            value: "Promotion",
            label: this.$t("AccountSettingDefault.Promotion.Name"),
            warning: false
          }
        ]
        break;
      case 'si': 
        activeTabs = [
          // {
          //   value: "Store",
          //   label: this.$t("AccountSettingDefault.Store.Name"),
          //   warning: false
          // },
          // {
          //   value: "Advance",
          //   label: this.$t("AccountSettingDefault.Advance.Name"),
          //   warning: false
          // },
          // {
          //   value: "Time",
          //   label: this.$t("AccountSettingDefault.Time.Name"),
          //   warning: false
          // },
          {
            value: "Logistic",
            label: this.$t("AccountSettingDefault.Logistic.Name"),
            warning: false
          },
          // {
          //   value: "Printer",
          //   label: this.$t("AccountSettingDefault.Printer.Name"),
          //   warning: false
          // },
          {
            value: "Promotion",
            label: this.$t("AccountSettingDefault.Promotion.Name"),
            warning: false
          },
        
          // {
          //   value: "EInvoice",
          //   label: this.$t("AccountSettingDefault.EInvoice.Name"),
          //   warning: false
          // },
        ];
      break;
      case 'gaa':
        break;
      default: 
        break;
     }
     return activeTabs;
    //  return [
    //     {
    //       value: "Store",
    //       label: this.$t("AccountSettingDefault.Store.Name"),
    //       warning: false
    //     },
    //     {
    //       value: "Advance",
    //       label: this.$t("AccountSettingDefault.Advance.Name"),
    //       warning: false
    //     },
    //     {
    //       value: "Time",
    //       label: this.$t("AccountSettingDefault.Time.Name"),
    //       warning: false
    //     },
    //     {
    //       value: "Logistic",
    //       label: this.$t("AccountSettingDefault.Logistic.Name"),
    //       warning: false
    //     },
    //     {
    //       value: "Printer",
    //       label: this.$t("AccountSettingDefault.Printer.Name"),
    //       warning: false
    //     },
    //     // {
    //     //   value: "Qrpay",
    //     //   label: "金流",
    //     //   warning: false
    //     // },
    //     {
    //       value: "Contract",
    //       label: this.$t("AccountSettingDefault.Contract.Name"),
    //       warning: false
    //     },
    //     {
    //       value: "Promotion",
    //       label: this.$t("AccountSettingDefault.Promotion.Name"),
    //       warning: false
    //     },
    //     {
    //       value: "Other",
    //       label: this.$t("AccountSettingDefault.Other.Name"),
    //       warning: false
    //     },
    //     {
    //       value: 'Qrpay',
    //       label: this.$t("AccountSettingDefault.Qrpay.Name"),
    //       warning: false
    //     },
    //     {
    //       value: "EInvoice",
    //       label: this.$t("AccountSettingDefault.EInvoice.Name"),
    //       warning: false
    //     },
    //     {
    //       value: "Record",
    //       label: this.$t("AccountSettingDefault.Record.Name"),
    //       warning: false
    //     }
    //   ]
    },
    numberedAccountId: function() {
      return Number(this.accountId);
    },
    currentTabComponent: function() {
      return "AccountSetting" + this.currentTab;
    }
  },
  watch: {
    editStatusArr: function(newVal, oldVal) {
      console.log("editStatusArr: ", newVal, oldVal)
      var that = this;
      if(newVal.length == 0) {
        that.tabs.forEach(tab => tab.warning = false);
      }
      newVal.forEach(element => {
        that.tabs.forEach(tab => {
          if(tab.value == element.value) {
            tab.warning = true;
          } else {
            tab.warning = false;
          }
        });
      });
    }
  }
};
</script>
<style scoped src="../../../../src/assets/css/shop-console.css"></style>
